import { auth } from '../firebase';

/**
 * Generates an anonymous hash for tracking guest users.
 * Replicated logic from chat.js
 */
export function getAnonHash() {
    const localIdKey = "routechef_anon_id";

    // Stable UUID stored in localStorage
    let anonId = localStorage.getItem(localIdKey);
    if (!anonId) {
        anonId = crypto.randomUUID();
        localStorage.setItem(localIdKey, anonId);
    }

    // Components that contribute to the hash
    const fingerprint = [
        navigator.userAgent,
        navigator.platform,
        window.screen.width + "x" + window.screen.height,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        navigator.language,
        anonId,
    ].join("|");

    // Simple hash function (FNV-1a for example)
    let hash = 2166136261;
    for (let i = 0; i < fingerprint.length; i++) {
        hash ^= fingerprint.charCodeAt(i);
        hash +=
            (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }

    const id = "anon" + (hash >>> 0).toString(16);
    return id;
}

/**
 * Gets the current user identifier or generates an anonymous one.
 */
export const getUserIdentifier = () => {
    try {
        const user = auth.currentUser;
        if (user) {
            return user.phoneNumber || user.email || getAnonHash();
        }
    } catch (error) {
        console.error("Error getting auth user:", error);
    }
    return getAnonHash();
};
